import { jsx as a } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...o,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentcolor",
        d: "M3 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0M10 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0M17.586 6.414a2 2 0 1 1 2.828-2.828 2 2 0 0 1-2.828 2.828M3 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0M10.586 13.414a2 2 0 1 1 2.828-2.828 2 2 0 0 1-2.828 2.828M17 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0M3.586 20.414a2 2 0 1 1 2.828-2.828 2 2 0 0 1-2.828 2.828M17 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0M10.586 20.414a2 2 0 1 1 2.828-2.828 2 2 0 0 1-2.828 2.828"
      }
    )
  }
);
export {
  t as default
};
